require('./RegisterEditableInputs.scss');
import React from 'react';
import PropTypes from 'prop-types';

import { getText } from '../../texts/login';
import Input from '../../atoms/Input';
import {
    //isValidPhoneNumber,
    isValidPin,
    isValidString,
    isValidEmail,
    //isValidPostalCode
} from '../../validation/validation';
import { formatPhoneNumber } from '../../utils/helper';

class RegisterEditableInputs2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: props.edit || false
        };
    }

    editMode = () => {
        this.setState({ edit: true });
    };

    isInValid() {
        return  [
            !isValidString(this.state.firstName || this.props.firstName),
            !isValidString(this.state.lastName || this.props.lastName),
            //!isValidString(this.state.streetAddress || this.props.streetAddress),
            //!isValidString(this.state.zipcode || this.props.zipcode),
            //!isValidString(this.state.city || this.props.city),
            //!isValidPhoneNumber(this.state.cellphone || this.props.cellphone),
            !isValidEmail(this.state.email || this.props.email),
            !isValidPin(this.state.pin || this.props.pin)
        ].some(validationResult => validationResult === true);
    }
       

    firstNameChanged = firstName => {
        this.props.firstName = firstName;
        this.props.onInputChange({ firstName });
    };

    lastNameChanged = lastName => {
        this.props.lastName = lastName;
        this.props.onInputChange({ lastName });
    };

    streetAddressChanged = streetAddress => {
        this.props.streetAddress = streetAddress;
        this.props.onInputChange({ streetAddress });
    };

    zipcodeChanged = zipcode => {
        this.props.zipcode = zipcode;
        this.props.onInputChange({ zipcode });
    };

    cityChanged = city => {
        this.props.city = city;
        this.props.onInputChange({ city });
    };

    phoneChanged = cellphone => {
        this.props.cellphone = cellphone;
        this.props.onInputChange({ cellphone });
    };

    emailChanged = email => {
        this.props.email = email;
        this.props.onInputChange({ email });
        
    };

    pinChanged = pin => {
        this.props.pin = pin;
        this.props.onInputChange({ pin });
    };

    renderInfo() {
        return (
            <div className="register-editable-inputs spacer-bottom-1">
                <div className="info-row spacer-bottom-half">{`${this.props.firstName} ${
                    this.props.lastName
                }`}</div>
                <div className="hidden info-row spacer-bottom-half">{this.props.streetAddress}</div>
                <div className="hidden info-row spacer-bottom-half">{`${this.props.zipcode} ${
                    this.props.city
                }`}</div>
                <div className="info-row spacer-bottom-half">
                    {formatPhoneNumber(this.props.cellphone)}
                </div>
                <input name="firstname" type="hidden" value={this.props.firstName} />
                <input name="lastname" type="hidden" value={this.props.lastName} />
                <input name="streetAddress" type="hidden" value={/*this.props.streetAddress*/ "Not set"} />
                <input name="oidstreetaddress" type="hidden" value={/*this.props.streetAddress*/ "Not set"} />
                <input name="postalcode" type="hidden" value={/*this.props.zipcode*/ "Not set"} />
                <input name="postalcity" type="hidden" value={/*this.props.city*/ "Not set"} />
                <input name="username" type="hidden" value={this.props.cellphone} />
                
                <button onClick={this.editMode} className="spacer-bottom-3" type="button">
                    {getText('register.change-data-button')}
                </button>
                
                {this.renderEmailAndPin()}
            </div>
        );
    }

    renderEdit() {
        return (
            <div className="register-editable-inputs">
                <Input
                    type="text"
                    id="firstName"
                    name="firstname"
                    label={getText('register.firstname.placeholder')}
                    defaultValue={this.props.firstName}
                    spacers={3}
                    validationMessage={getText('validation.firstname')}
                    isValid={isValidString}
                    onChange={this.firstNameChanged}
                    submitted={this.props.submitted}
                    autoComplete="given-name"
                />

                <Input
                    type="text"
                    id="lastname"
                    name="lastname"
                    label={getText('register.lastname.placeholder')}
                    defaultValue={this.props.lastName}
                    spacers={3}
                    validationMessage={getText('validation.lastname')}
                    isValid={isValidString}
                    onChange={this.lastNameChanged}
                    submitted={this.props.submitted}
                    autoComplete="family-name"
                />
                <input
                    id="streetAddress"
                    name="addressLine1"
                    type="hidden"
                    value={"Not set"}
                />
                <input
                    name="oidstreetaddress"
                    type="hidden"
                    value={"Not set"}
                />
                <input
                    id="zipcode"
                    name="postalcode"
                    type="hidden"
                    value={"Not set"}
                />
                <input
                    id="city"
                    name="postalcity"
                    type="hidden"
                    value={"Not set"}
                />
                <input
                    id="phone"
                    name="username"
                    type="hidden"
                    value={this.props.cellphone}
                />
                {this.renderEmailAndPin()}
            </div>
        );
    }

    renderEmailAndPin() {
        return (
            <div>
                <Input
                    type="text"
                    id="pin"
                    name="pin"
                    defaultValue={this.props.pin}
                    label={getText('register.pin.placeholder')}
                    spacers={3}
                    validationMessage={getText('validation.pin')}
                    isValid={isValidPin}
                    onChange={this.pinChanged}
                    autoComplete="one-time-code"
                    submitted={this.props.submitted}
                    autoFocus={true}
                />

                <Input
                    type="email"
                    id="email"
                    name="email"
                    label={getText('register.email.placeholder')}
                    spacers={3}
                    autoComplete="email"
                    validationMessage={getText('validation.email')}
                    isValid={isValidEmail}
                    defaultValue={this.props.email}
                    onChange={this.emailChanged}
                    submitted={this.props.submitted}
                />
            </div>
        );
    }

    render() {
        if (this.props.edit || this.state.edit) {
            return this.renderEdit();
        } else {
            return this.renderInfo();
        }
    }
}

RegisterEditableInputs2.propTypes = {
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    streetAddress: PropTypes.string.isRequired,
    zipcode: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    cellphone: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    submitted: PropTypes.bool.isRequired,
    edit: PropTypes.bool,
    onInputChange: PropTypes.func,
    pin: PropTypes.number
};

export default RegisterEditableInputs2;
